import React, { Component } from "react";
import { connect } from "react-redux";
import { guardaCat, uploadImgCategoria} from "../actions/admin";
import AdminMenu from "../components/admin_menu";
import Switch from "../components/switch";

class AdminCategoria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: "",
      rubro: null,
      orden: 0,
      estado: 1,
      id_rubro: 0,
      img:null,
      xtra: "",
      descripcion:"",
      venta_online: false,
      loading: false,
      file: null
    };
    this.cambia = this.cambia.bind(this);
    this.envia = this.envia.bind(this);
    this.switchHandle = this.switchHandle.bind(this);
    this.rubroChange = this.rubroChange.bind(this);
    this.validaForm = this.validaForm.bind(this);
    this.uploadImg = this.uploadImg.bind(this)
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }
    if (this.props.match.params.id) {
      console.log("MODIFICA");

      var categoria = this.props.productos.categorias.find((cat, i) => {
        return cat.id == this.props.match.params.id.toString();
      });

      if (categoria) {
        categoria.id_rubro = categoria.rubro.id;
        if(categoria.hasOwnProperty("img")){
          categoria.img=categoria.img
        }
      }

      this.setState(categoria);
    } else {
      console.log("AGREGA");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.productos.contador > prevProps.productos.contador) {
      this.props.history.push("/admin/categorias");
    }
  }

  handleChangeCategoria = file => {
    this.setState({ file: file });
  };

  uploadImg() {
    if (this.state.file) {
      this.setState({ loading: true }, () => {
        this.props.uploadImgCategoria(this.props.match.params.id, this.state.img, this.state.file);
      })
    }else{
      console.log("DEBE SELECCIONAR UN ARCHIVO")
    }
  }

  validaForm = () => {
    if (this.state.nombre == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL NOMBRE"
      };
    } else {
      return {
        resp: true,
        msj: "PASO LA VALIDACION"
      };
    }
  };

  cambia = (key, value) => {
    this.setState({ [key]: value });
  };

  envia = e => {
    this.setState({ loading: true }, () => {
      const valida = this.validaForm();
      if (valida.resp) {
        const categoriaSend = {
          nombre: this.state.nombre,
          rubro: this.state.rubro,
          orden: parseInt(this.state.orden),
          estado: this.state.estado,
          descripcion: this.state.descripcion,
          xtra: this.state.xtra,
          venta_online: this.state.venta_online,
          img:this.state.img
        };
        if (this.props.match.params.id) {
          this.props.guardaCat(this.props.match.params.id, categoriaSend);
        } else {
          this.props.guardaCat(null, categoriaSend);
        }
      } else {
        this.setState({ alert: valida.msj, loading: false });
      }
    });
  };

  switchHandle = (campo, valor) => {
    this.setState({ [campo]: valor });
  };

  rubroChange(e) {
    const rubroNew = this.props.productos.rubros.find(rubro => {
      return rubro.id == e.target.value;
    });
    console.log(rubroNew);
    this.setState({
      rubro: {
        id: rubroNew.id,
        nombre: rubroNew.nombre,
        orden: rubroNew.orden
      }
    });
  }

  render() {
    if (this.state.loading) {
      return <div>CARGANDO</div>;
    }

    const rubros = this.props.productos.rubros.map((rubro, i) => {
      return (
        <option value={rubro.id} key={i} name={i}>
          {rubro.nombre}
        </option>
      );
    });

    return (
      <div className="container">
        <section className="row mb-5 sombraHead mt-3 clearfix">
          <div className="col-md-3 mb-3">
            <AdminMenu />
          </div>

          <div className="col-md-9 p-3">
            <div className="container">
              <div>
                <h1 className="display-4">Categoria</h1>
              </div>
              {this.props.match.params.id && (
                <section className="row">
                  <div className="col-md-12 mb-3">
                    <div className="card" style={{ width: "18rem" }}>
                      <img
                        className="card-img-top"
                        src={
                          "https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F" +
                          this.state.img +
                          "?alt=media"
                        }
                        alt={this.state.nombre}
                      />
                      <div className="card-body">
                        <h5 className="card-title">IMAGEN</h5>
                        {!this.state.loading && (
                          <div className="row">
                            <input
                              type="file"
                              className="form-control col"
                              id="categoriaImg"
                              onChange={e =>
                                this.handleChangeCategoria(e.target.files)
                              }
                            />
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={this.uploadImg}
                            >
                              <i className="fas fa-angle-right" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              )}
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label>Nombre</label>
                  <input
                    type="text"
                    className="form-control"
                    id="nombre"
                    value={this.state.nombre}
                    aria-describedby="emailHelp"
                    placeholder="Ingrese el nombre del producto"
                    onChange={evt => this.cambia("nombre", evt.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>RUBROS</label>
                  <select
                    className="form-control"
                    id="rubro"
                    value={this.state.id_rubro}
                    onChange={this.rubroChange}
                  >
                    <option value="0">SELECCIONAR</option>
                    {rubros}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <label>DESCRIPCION</label>
                <textarea
                  className="form-control"
                  id="xtra"
                  value={this.state.descripcion}
                  rows="5"
                  placeholder="Descripcion de la categoria"
                  onChange={evt => this.cambia("descripcion", evt.target.value)}
                />
              </div>

              <div className="form-row">
                <label>Contenido para cuando no se vende online</label>
                <textarea
                  className="form-control"
                  id="xtra"
                  value={this.state.xtra}
                  rows="5"
                  placeholder="Html para cuando no se vende online"
                  onChange={evt => this.cambia("xtra", evt.target.value)}
                />
              </div>

              <div className="form-row">
                <div className="col-md-4 mb-3">
                  <label>ORDEN</label>
                  <input
                    type="number"
                    className="form-control"
                    name="orden"
                    value={this.state.orden}
                    placeholder="Ingrese el orden"
                    onChange={evt =>
                      this.cambia("orden", parseInt(evt.target.value))
                    }
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label>VENTA ONLINE</label>
                  <Switch
                    switchAct={this.switchHandle}
                    dato="venta_online"
                    off_valor={false}
                    on_valor={true}
                    off="NO"
                    on="SI"
                    stat={this.state.venta_online}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label>ESTADO</label>
                  <Switch
                    switchAct={this.switchHandle}
                    dato="estado"
                    off_valor={0}
                    on_valor={1}
                    off="NULO"
                    on="ACTIVO"
                    stat={this.state.estado}
                  />
                </div>
              </div>
              <div className="form-row">
                {this.props.match.params.id ? (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={this.envia}
                  >
                    ACTUALIZAR
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={this.envia}
                  >
                    AGREGAR
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    productos: state.productos,
    usuario: state.usuario
  };
};

const mapDispatchToProps = dispatch => {
  return {
    guardaCat: (id, datos) => {
      dispatch(guardaCat(id, datos));
    },
    uploadImgCategoria: (id_categoria, imgActual, file) =>{
      dispatch(uploadImgCategoria(id_categoria, imgActual, file))
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCategoria);



// WEBPACK FOOTER //
// ./src/containers/categoria_form.js